import React from 'react'

const MosinzhproektGrayLogo: React.FC<
  React.SVGProps<SVGSVGElement>
> = props => (
  <svg
    width="140"
    height="28"
    viewBox="0 0 140 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_30479_11794)">
      <path
        d="M13.6414 17.8456L8.61694 27.9095H16.635L23.8149 13.8905L17.8324 2.87109H10.2886L17.9522 17.8456H13.6414Z"
        fill="#8F98A1"
      />
      <path
        d="M7.17986 0L0 14.019L5.98241 25.0384H13.5215L5.86267 10.0638H10.1735L15.1979 0H7.17986Z"
        fill="#8F98A1"
      />
      <path
        d="M99.541 19.5447H102.635V12.7658H104.58C106.069 12.7135 107.454 11.2493 107.454 9.20992V5.40687C107.521 2.6449 105.672 1.77019 104.12 1.72266H99.5458V19.5495L99.541 19.5447ZM102.635 9.99906C102.65 8.10704 102.659 6.21977 102.674 4.32775H103.095C103.837 4.28972 104.312 4.78412 104.336 5.96782C104.336 7.06595 104.321 7.32741 104.321 8.42079C104.321 9.44286 104.125 9.98955 103.239 10.0086C102.966 10.0086 102.908 9.9943 102.63 9.9943"
        fill="#8F98A1"
      />
      <path
        d="M111.99 4.31253C111.602 4.31253 111.276 4.68333 111.276 5.13494V16.0735C111.276 16.5251 111.597 16.8959 111.99 16.8959H112.076C112.469 16.8959 112.785 16.5251 112.785 16.0735V5.13494C112.785 4.68333 112.469 4.31253 112.076 4.31253H111.99ZM108.148 5.10166H108.182C108.239 3.05277 109.7 1.39844 111.482 1.39844H112.77C114.586 1.39844 116.075 3.11932 116.075 5.22526V16.0022C116.075 18.1081 114.586 19.829 112.77 19.829H111.482C109.829 19.829 108.45 18.4029 108.215 16.5584L108.148 16.1686V5.10166Z"
        fill="#8F98A1"
      />
      <path
        d="M32.5897 19.5436H29.9697V1.7168H34.6206L35.7701 13.2686H36.0144L37.1544 1.7168H41.8052V19.5436H38.9266V6.49439H38.6536L37.1975 19.5436H34.2422L32.8244 6.49439H32.5897V19.5436Z"
        fill="#8F98A1"
      />
      <path
        d="M42.5525 5.10166V16.1638L42.6148 16.5536C42.8495 18.3981 44.2289 19.8242 45.8814 19.8242H47.1698C48.9851 19.8242 50.47 18.1034 50.47 15.9974V5.22526C50.47 3.11932 48.9851 1.39844 47.1698 1.39844H45.8814C44.0996 1.39844 42.6387 3.05277 42.5812 5.10166H42.5525ZM46.3939 4.31253H46.4801C46.8681 4.31253 47.189 4.68333 47.189 5.13494V16.0735C47.189 16.5251 46.8681 16.8959 46.4801 16.8959H46.3939C46.0059 16.8959 45.685 16.5251 45.685 16.0735V5.13494C45.685 4.68333 46.0059 4.31253 46.3939 4.31253Z"
        fill="#8F98A1"
      />
      <path
        d="M51.303 5.10166H51.3365C51.394 3.05277 52.8549 1.39844 54.6367 1.39844H55.9251C57.7404 1.39844 59.2252 3.11932 59.2252 5.22526V8.16788H55.9443V5.13494C55.9443 4.68333 55.6233 4.31253 55.2354 4.31253H55.1492C54.7612 4.31253 54.4403 4.68333 54.4403 5.13494V16.0735C54.4403 16.5251 54.7612 16.8959 55.1492 16.8959H55.2354C55.6281 16.8959 55.9443 16.5251 55.9443 16.0735V12.4891H59.2252V15.9974C59.2252 18.1034 57.7404 19.8242 55.9251 19.8242H54.6367C52.9842 19.8242 51.6047 18.3981 51.37 16.5536L51.3078 16.1638V5.10166H51.303Z"
        fill="#8F98A1"
      />
      <path
        d="M64.7581 1.7168H67.9385V19.5436H65.079V10.1929L63.1009 19.5436H59.8342V1.7168H62.7799V10.8869L64.7581 1.7168Z"
        fill="#8F98A1"
      />
      <path
        d="M73.461 1.7168H76.7325V19.5436H73.461V11.1008H71.8948V19.5436H68.6282V1.7168H71.8948V8.22002H73.461V1.7168Z"
        fill="#8F98A1"
      />
      <path
        d="M80.4447 1.7168H77.1445L79.1227 8.96637V10.3022L77.2355 19.5436H80.3249L81.9343 11.4241H82.1163V19.5436H85.3398V11.4241H85.541L87.0929 19.5436H90.4074L88.3334 10.4068V9.128L90.3595 1.7168H87.1839L85.4596 8.83802V1.7168H82.1163V8.86179L80.4447 1.7168Z"
        fill="#8F98A1"
      />
      <path
        d="M90.8477 19.5436V1.7168H98.837V19.5436H95.5464V4.59761H94.0999V19.5436H90.8477Z"
        fill="#8F98A1"
      />
      <path
        d="M123.288 4.38369V1.7168H116.971V19.5436H123.288V16.7626H120.055V10.9677H123.288V8.18675H120.055V4.38369H123.288Z"
        fill="#8F98A1"
      />
      <path
        d="M123.782 19.5436V1.7168H126.967V9.03768H127.259L129.022 1.7168H132.207L129.956 9.26586V9.89337L132.059 19.5436H128.874L127.159 11.1056L126.914 11.1103V19.5436H123.782Z"
        fill="#8F98A1"
      />
      <path
        d="M132.423 1.7168V4.5881H134.554V19.5436H137.869V4.54532H140V1.7168H132.423Z"
        fill="#8F98A1"
      />
      <path
        d="M32.8101 23.745V24.2394H30.5541V27.8808H29.9697V23.7402H32.8101V23.745Z"
        fill="#8F98A1"
      />
      <path
        d="M34.4867 27.8867H33.9023V23.7461H35.8566C36.6565 23.7461 37.1402 24.2405 37.1402 24.9108C37.1402 25.486 36.7954 26.142 35.8566 26.142H34.4867V27.8867ZM34.4867 25.6619H35.6506C36.1775 25.6619 36.5367 25.4717 36.5367 24.9155C36.5367 24.3974 36.1583 24.2262 35.6746 24.2262H34.4867V25.6619Z"
        fill="#8F98A1"
      />
      <path
        d="M41.9009 23.7461L40.2724 27.2306C39.9802 27.8629 39.6881 28.0008 39.3336 28.0008C39.1851 28.0008 39.0271 27.977 38.9073 27.9532V27.4921C39.0079 27.5111 39.1037 27.5159 39.2474 27.5159C39.4677 27.5159 39.53 27.4541 39.7264 27.1166L38.0452 23.7461H38.6726L40.0042 26.5746L41.2639 23.7461H41.8913H41.9009Z"
        fill="#8F98A1"
      />
      <path
        d="M46.4655 23.7461V27.8867H45.8812V24.2452H43.6156V27.8867H43.0312V23.7461H46.4703H46.4655Z"
        fill="#8F98A1"
      />
      <path
        d="M51.3852 23.7461V27.8867H50.8008V24.2452H48.5353V27.8867H47.9509V23.7461H51.39H51.3852Z"
        fill="#8F98A1"
      />
      <path
        d="M53.5688 26.6792L53.1138 27.8867H52.5103L54.1436 23.7461H54.8093L56.3756 27.8867H55.7338L55.3027 26.6792H53.5688ZM55.0919 26.1896L54.4549 24.3641H54.4405L53.746 26.1896H55.0919Z"
        fill="#8F98A1"
      />
      <path
        d="M60.351 25.7511L62.4538 23.745H63.2632L61.4575 25.4136L63.3111 27.8808H62.5543L61.036 25.8034L60.3558 26.4261V27.8808H59.7715V23.7402H60.3558V25.7463L60.351 25.7511Z"
        fill="#8F98A1"
      />
      <path
        d="M66.1609 27.9951C64.5419 27.9951 64.0486 26.7116 64.0486 25.8179C64.0486 24.9242 64.5371 23.6406 66.1609 23.6406C67.7846 23.6406 68.2732 24.9242 68.2732 25.8179C68.2732 26.7116 67.7846 27.9951 66.1609 27.9951ZM66.1609 24.135C65.2173 24.135 64.6521 24.8291 64.6521 25.8036C64.6521 26.7781 65.2125 27.496 66.1609 27.496C67.1092 27.496 67.6696 26.7877 67.6696 25.8131C67.6696 24.8386 67.1092 24.1303 66.1609 24.1303V24.135Z"
        fill="#8F98A1"
      />
      <path
        d="M70.4144 23.7461L71.6454 27.2449H71.6597L72.8955 23.7461H73.7289V27.8867H73.1589V25.4385C73.1589 25.3196 73.1781 24.7872 73.1781 24.4069H73.1733L71.9471 27.8867H71.3675L70.1462 24.4069H70.127C70.127 24.7824 70.1462 25.3196 70.1462 25.4385V27.8867H69.5762V23.7461H70.4144Z"
        fill="#8F98A1"
      />
      <path
        d="M78.6481 23.7461V27.8867H78.0638V24.2452H75.7982V27.8867H75.2139V23.7461H78.6529H78.6481Z"
        fill="#8F98A1"
      />
      <path
        d="M80.8273 26.6792L80.3723 27.8867H79.7688L81.4021 23.7461H82.0679L83.6341 27.8867H82.9923L82.5612 26.6792H80.8273ZM82.3505 26.1896L81.7134 24.3641H81.6991L81.0046 26.1896H82.3505Z"
        fill="#8F98A1"
      />
      <path
        d="M85.3395 25.4575H87.605V23.7461H88.1894V27.8867H87.605V25.9519H85.3395V27.8867H84.7551V23.7461H85.3395V25.4575Z"
        fill="#8F98A1"
      />
      <path
        d="M90.2632 27.1347H90.2872L92.4857 23.75H93.1562V27.8906H92.5719V24.5486H92.5575L90.3494 27.8906H89.6741V23.75H90.2584V27.1347H90.2632Z"
        fill="#8F98A1"
      />
      <path
        d="M95.221 27.1349H95.2449L97.4434 23.7502H98.114V27.8908H97.5296V24.5489H97.5153L95.3072 27.8908H94.6318V23.7502H95.2162V27.1349H95.221ZM96.3322 23.0752C96.7393 23.0752 96.8639 22.8945 96.9357 22.6426H97.2279C97.2039 22.847 97.1273 23.4317 96.3322 23.4317C95.5371 23.4317 95.4557 22.8517 95.4317 22.6426H95.7287C95.8053 22.8945 95.9203 23.0752 96.3322 23.0752Z"
        fill="#8F98A1"
      />
    </g>
    <defs>
      <clipPath id="clip0_30479_11794">
        <rect width="140" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default MosinzhproektGrayLogo
